export default "__VITE_ASSET__CwTx7vSS__"